import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { reportGrainMetricValue } from '../models/reportGrainMetricValue';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  constructor(private http:HttpClient, private configService:ConfigurationService) {
    this.baseUrl = this.configService.getApiEndpoint();
  }
  
  baseUrl:string;

  async getGrainMetricValueReport(username:string, reportId:string):Promise<reportGrainMetricValue[]> {
    let endpoint = `${this.baseUrl}/report`;
    let request = { username: username, reportId: reportId };
    let result = await firstValueFrom(this.http.post<reportGrainMetricValue[]>(endpoint, request));
    return result;
  }
}
